// extracted by mini-css-extract-plugin
module.exports = {"wrap":"SelectionList_wrap__nZk6j","selection":"SelectionList_selection__fDdEt","name":"SelectionList_name__1tezJ"};